import Helpers from '../../common/helpers/Helpers';
import Constants from '../../common/constants/Constants';

export const getGroup = (groupId) => {
  return Helpers.get(`${Constants.GROUPS_URL}/${groupId}`);
};

export const updateGroup = (group) => {
  return Helpers.put(Constants.GROUPS_URL, {}, group);
};

export const getUsersOfGroup = (groupId) => {
  return Helpers.get(`${Constants.GROUPS_URL}/${groupId}/users`);
};

export const addUserToGroup = (groupId, userId) => {
  return Helpers.post(`${Constants.GROUPS_URL}/${groupId}/users/${userId}`);
};

export const removeUserFromGroup = (groupId, userId) => {
  return Helpers.delete(`${Constants.GROUPS_URL}/${groupId}/users/${userId}`);
};

export const moveInstrumentToGroup = (groupId, serialnumber) => {
  console.log(serialnumber);
  return Helpers.put(`${Constants.GROUPS_URL}/${groupId}/instruments/${serialnumber}`, {}, {});
};

export const getInstrumentsOfGroup = (groupId) => {
  return Helpers.get(`${Constants.GROUPS_URL}/${groupId}/instruments`);
};

export const addInstrumentToGroup = (groupId, serialnumber) => {
  return Helpers.post(`${Constants.GROUPS_URL}/${groupId}/instruments/${serialnumber}`);
};

export const removeInstrumentFromGroup = (groupId, serialnumber) => {
  return Helpers.delete(`${Constants.GROUPS_URL}/${groupId}/instruments/${serialnumber}`);
};

export const getAssignableUsersToGroup = (groupId) => {
  return Helpers.get(`${Constants.GROUPS_URL}/${groupId}/unassignedusers`);
};

export const getAssignableIstrumentsToGroup = () => {
  return Helpers.get(Constants.INSTRUMENTS_URL);
};
